import { resolveModuleNameDisplayEnabled } from './moduleNameDisplay';

const {
  REACT_APP_API_URL,
  REACT_APP_API_VIA_CEP,
  REACT_APP_SUPPORT_WHATSAPP,
  REACT_APP_AUTH_USE_COOKIES,
  REACT_APP_LANDING_ENABLED,
  REACT_APP_ASAAS_ENABLED,
  REACT_APP_MODULE_NAME_DISPLAY,
  REACT_APP_BRIDGE_RETURN_HOSTS,
} = process.env;

const AUTH_USE_COOKIES = REACT_APP_AUTH_USE_COOKIES === 'true';

/** Landing pública em `/` — desativar em produção com `REACT_APP_LANDING_ENABLED=false`. */
const LANDING_ENABLED = REACT_APP_LANDING_ENABLED !== 'false';

/** Checkout Asaas em `/assinar` — desativar em dev/staging com `REACT_APP_ASAAS_ENABLED=false`. */
const ASAAS_ENABLED = REACT_APP_ASAAS_ENABLED !== 'false';

const MODULE_NAME_DISPLAY_ENABLED = resolveModuleNameDisplayEnabled(
  process.env.NODE_ENV,
  REACT_APP_MODULE_NAME_DISPLAY
);

export {
  REACT_APP_API_URL,
  REACT_APP_API_VIA_CEP,
  REACT_APP_SUPPORT_WHATSAPP,
  REACT_APP_AUTH_USE_COOKIES,
  REACT_APP_LANDING_ENABLED,
  REACT_APP_ASAAS_ENABLED,
  REACT_APP_MODULE_NAME_DISPLAY,
  REACT_APP_BRIDGE_RETURN_HOSTS,
  AUTH_USE_COOKIES,
  LANDING_ENABLED,
  ASAAS_ENABLED,
  MODULE_NAME_DISPLAY_ENABLED,
};
